import type { RoundaboutRoomUser } from "./roundabout-markings";
import type { User } from "@auth0/auth0-react";

export const makeUserDetails = (
  user: User,
): Pick<RoundaboutRoomUser, "blobLetter" | "nickname" | "userId"> => {
  const nickname = user.nickname || user.name || "?";
  const blobLetter = nickname[0]!.toUpperCase();
  return {
    blobLetter,
    nickname,
    userId: user.sub!,
  };
};

// Filter for only editor role people
// Optional if mySub then only other people
export const getOtherEditors = (
  roomUsers: RoundaboutRoomUser[],
  mySub?: string,
): RoundaboutRoomUser[] =>
  roomUsers
    .filter((currentUser) => currentUser.role === "Editing")
    .filter((currentUser) => !mySub || currentUser.userId !== mySub);

// It can be a bit unstable with websocket hybernation.
export const CLASH_FORCE_SINGLE_SESSION = false;
